import { inject, Injectable } from '@angular/core';
import {finalize, forkJoin, Observable, of, tap} from 'rxjs';
import {Resolve, Router} from '@angular/router';
import { BrandsService } from './brands.service';
import { DashboardService } from './dashboard.service';
import { CompetitionFiltersResponse } from '../components/my-brand-screen/types';
import { CommonDashboardService } from './common-dashboard.service';
import { CommonDashboardFilterResponse } from './types';
import {StateService} from './state.service';
import {RoutePaths} from '../shared/types/common';

@Injectable({
  providedIn: 'root'
})
export class BrandsFiltersResolverService implements Resolve<any> {

  private brandsService = inject(BrandsService);
  private dashboardService = inject(DashboardService);
  private commonDashboardService = inject(CommonDashboardService);
  private stateService = inject(StateService);
  private router = inject(Router);

  constructor() {}

  resolve(): Observable<{brands: CompetitionFiltersResponse, common: CommonDashboardFilterResponse}> {
    if(!this.stateService.activeAccount()){
      this.router.navigate([RoutePaths.WORKSPACE_ERROR]);
    }
    const dateRange = this.dashboardService.dateRange();

    const observables: (Observable<CompetitionFiltersResponse> | Observable<CommonDashboardFilterResponse>)[] = [];
    
      if(this.dashboardService.competitionFiltersResponse) {
        observables.push(of(this.dashboardService.competitionFiltersResponse));
      } else {
        this.stateService.loading = true;
        observables.push(
          this.brandsService.getMyCompetitionFilters(dateRange, this.stateService.activeAccount()).pipe(
          tap((competitionFilters) => {
            this.dashboardService.setInitialBrandsFilters(competitionFilters);
          }),
          finalize(()=>{
            this.stateService.loading = false
          })
        ));
      }

      if(this.dashboardService.commonFiltersResponse) {
        observables.push(of(this.dashboardService.commonFiltersResponse));
      } else {
        this.stateService.loading = true;
        observables.push(this.commonDashboardService.getFilters().pipe(
          tap((commonFilters) => {
            this.dashboardService.setInitialCommonFilters(commonFilters);
          }),
          finalize(()=> this.stateService.loading = false)
        ));
      }
    return forkJoin({
      brands: observables[0] as Observable<CompetitionFiltersResponse>,
      common: observables[1] as Observable<CommonDashboardFilterResponse>
    });
  }
}
